import React, { useState } from 'react';
import MainStructure from "../components/layout/MainStructure/MainStructure";
import PanelSample from "../components/layout/MainStructure/PanelMainStructure";
import { Panel } from '@appkit4/react-components/panel';


export default function Home() {
  const [showWelcome] = useState(() => {
    return localStorage.getItem('welcomeClosed') !== 'true';
  });



  return (
    <MainStructure>
      <div className="main-content-wrapper">
          {showWelcome && (
            <div className="welcome-section" >
              <Panel 
              style={{backgroundColor:'#3B3B3B'}}
              >
                <div style={{fontSize: 24, fontWeight: 'bold', paddingBottom: 14, paddingTop:10}}>Benvenuto su Document Operations Toolbox!</div>
                <div className="welcome-content">
                  <p className="welcome-description">
                    Questa piattaforma offre strumenti per trasformare, gestire e confrontare i tuoi documenti. Seleziona uno strumento qui sotto per iniziare.
                  </p>
                </div>
              </Panel>
            </div>
          )}
          
          <div className="panel-grid-container">
            <PanelSample
              title="PDF to TXT"
              description="Mantieni il layout quando trasformi i tuoi PDF in file .txt o .html"
              navigateTo="/pdftotxt"
              iconClass="Appkit4-icon icon-document-text-outline"
              customIcon="pdf-to-txt"
              isActive={true}
            />
            <PanelSample
              title="Convertitore P7M"
              description="Decripta i tuoi file .P7M nel formato XLM o PDF"
              navigateTo="/p7mpage"
              iconClass="Appkit4-icon icon-lockopen-unlock-outline"
              customIcon="p7m-to-pdf-xml"
              isActive={true}
            />
            <PanelSample
              title="DoCompare"
              description="Compara le versioni dei tuoi PDF digitali"
              navigateTo="/DoCompare"
              iconClass="Appkit4-icon icon-document-multiple-outline"
              customIcon="docompare-pdf-comparison"
              isActive={true}
            />
            <PanelSample
              title="DocSimilarity"
              description="Analizza la somiglianza tra documenti digitali e scannerizzati"
              navigateTo="/DocSimilarity"
              iconClass="Appkit4-icon icon-dial-high-outline"
              customIcon="doc-similarity"
              isActive={true}
              isNew={true}
            />
          </div>
        </div>
    </MainStructure>
  );
}
